import { getMagnitudeText } from 'BreetHelpers';
import { memo } from 'react';

export const FiatInputTooltip = memo(
	({ hideTooltip, value }: { hideTooltip?: boolean; value?: string | number | readonly string[] }) => {
		const tooltip = getMagnitudeText(value as string);

		return (
			<>
				{!hideTooltip && !!tooltip && (
					<div className='fiat_tooltip'>
						<span>{tooltip}</span>
					</div>
				)}
			</>
		);
	}
);

FiatInputTooltip.displayName = 'FiatInputTooltip';
